import { Component } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Home } from './home';
import { HomeNew } from './new/home-new';

/**
 * HomePage — the `/home` route entry point.
 *
 * Its only job is choosing which home page implementation to render:
 *
 *   `environment.homePageVersion === 'new'` → {@link HomeNew} (Figma redesign)
 *   anything else, including missing/invalid → {@link Home} (original page)
 *
 * The two implementations stay entirely separate; they only share services.
 */
@Component({
  selector: 'app-home-page',
  imports: [Home, HomeNew],
  templateUrl: './home-page.html',
})
export class HomePage {
  /** Only an explicit 'new' opts in; every other value falls back to the old page. */
  protected readonly isNewVersion = environment.homePageVersion === 'new';
}
